import { Box, Typography } from '@mui/material';

export const DashboardBodyCell = ({
  header,
  body,
  styleProps,
}: any) => {
  return (
    <Box sx={{ ...styleProps }}>
      <Typography
        sx={{ mt: 1 }}
        fontWeight={'bold'}
        variant="body1"
        component="div"
        gutterBottom
        color="text.primary"
      >
        {header}
      </Typography>
      <Typography
        sx={{ mt: 0, pt: 0 }}
        variant="body1"
        component="div"
        gutterBottom
        color="text.primary"
      >
        {body}
      </Typography>
    </Box>
  );
};
